import { useContext, useMemo } from 'react';
import DefaultContext from './Context';

const useAlert = () => {
    const alertContext = useContext(DefaultContext);

    const alert = useMemo(() => {
        return alertContext
    }, [alertContext]);

    return alert
}

export default useAlert